import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class UsageActivity  {
    _originalTypeClassName = "zAppDevManager.BO.UsageActivity";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
UsageActivity.translate = translateService;
}
this.ApplicationName = null;
this.Date = null;
this.IsSuccess = false;
this.Duration = null;
this.UsageActivityKey = null;
this._key = this.UsageActivityKey = 0; 
}

static translate: TranslateService;
_key: any;
ApplicationName:any;
Date:any;
IsSuccess:any;
Duration:any;
private _UsageActivityKey:any;
get UsageActivityKey(): any {
    return this._UsageActivityKey;
  }
set UsageActivityKey(value: any) {
    this._UsageActivityKey = value;
    this._key = value;
  }


static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.UsageActivityKey == null || $this.UsageActivityKey == 0;
            }


}